import makeStyles from '@material-ui/core/styles/makeStyles';

export const useBulkOperationsTaskStyles = makeStyles((theme) => ({
  on: {
    cursor: 'pointer',
  },
  isSelected: {
    backgroundColor: `${theme.palette.error.main}!important`,
    color: 'white!important',
    '& > div > p': {
      color: 'white!important',
    },
  },
}));
